// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';

export const updateShowMoreGroupsVisibility = isMoreSummaryVisible => ({
    isMoreSummaryVisible,
    type: actions.UPDATE_HOME_PAGE_LABOR_ADDITIVE_SHOW_MORE_GROUPS_VISIBILITY
});



// WEBPACK FOOTER //
// ./src/home-page/action-creators/show-more-groups-visibility.js